import { LinkId } from '../../../common/AnalyticsContext/LinkId';
import { useSearchFilters } from '../../../common/components/SearchHeader/filters/useSearchFilters';
import { Facets } from '../../../common/schema/hannibal/types.generated';
import { DropDownEnumFilter } from '../EnumFilter/DropDownEnumFilter/DropDownEnumFilter';
import { DropDownFilterPill } from '../FilterPill/DropDownFilterPill';
import { useOverlay } from '../overlay/OverlayContext';

interface Props {
  values: Facets['paymentMethods'];
}

const TITLE = 'Payment method';

export const EXCLUDE_OPTIONS = ['HICAPS'];

export const PaymentMethodsFilter = ({ values }: Props) => {
  const [filters, setFilters] = useSearchFilters();
  const { clear } = useOverlay();

  const availableValues = values?.filter(value => !EXCLUDE_OPTIONS.includes(value.term));

  const options = (availableValues ?? []).map(facetResult => ({
    label: facetResult.term,
    value: facetResult.term,
  }));

  const shouldHide = options.length === 0 || EXCLUDE_OPTIONS.includes(filters.paymentMethod ?? '');

  if (shouldHide) return null;

  const handleChange = (paymentMethod: string | undefined): void => {
    setFilters({ ...filters, paymentMethod });
    clear();
  };

  const handleClear = () => setFilters({ ...filters, paymentMethod: undefined });

  return (
    <DropDownFilterPill
      hasValue={filters.paymentMethod !== undefined}
      onClear={handleClear}
      caption={filters.paymentMethod ?? TITLE}
      trackingId={LinkId.FILTER_BY_PAYMENT_METHOD_BUTTON}
      content={
        <DropDownEnumFilter<string | undefined>
          value={filters.paymentMethod}
          filterTitle={TITLE}
          options={options}
          onChange={handleChange}
        />
      }
    />
  );
};
